import {
  Clock, Package, Truck, CheckCircle, XCircle,
  Banknote, CreditCard, QrCode, Layers,
} from "lucide-react";

/**
 * Mapa status → { label, color, icon }. Cores em Tailwind dark-mode aware.
 * Aceita os estados antigos (`aguardando`) por compatibilidade — vide
 * `getNormalizedStatus` pra mapear pro estado canônico.
 */
export const statusConfig = {
  aguardando_aceite: { label: "Aguardando Aceite", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: Clock },
  producao:          { label: "Em Produção",       color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: Clock },
  pronto:            { label: "Pronto",            color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: Package },
  na_bag:            { label: "Na Bag",            color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: Package },
  em_rota:           { label: "Em Rota",           color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400", icon: Truck },
  transito:          { label: "Em Trânsito",       color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: Truck },
  concluido:         { label: "Concluído",         color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: CheckCircle },
  cancelado:         { label: "Cancelado",         color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: XCircle },
  // Status legado do Delivery
  aguardando:        { label: "Em Produção",       color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: Clock },
};

/** Aceita alias `aguardando` (legado Delivery) como `producao` no resto da UI. */
export function getNormalizedStatus(status) {
  if (status === "aguardando") return "producao";
  return status;
}

/** Forma de pagamento → { label, icon }. Sem dependência de logos custom. */
export const formasPagamento = {
  dinheiro:           { label: "Dinheiro", icon: Banknote },
  cartao:             { label: "Cartão",   icon: CreditCard },
  credito:            { label: "Crédito",  icon: CreditCard },
  debito:             { label: "Débito",   icon: CreditCard },
  pix:                { label: "PIX",      icon: QrCode },
  multiplo:           { label: "Múltiplo", icon: Layers },
  ifood_marketplace:  { label: "iFood",    icon: CreditCard },
};
